<template>
  <div class="bidOrderDetail" :style="controlOrderStyle">
    <div class="tabWrap">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dateForm"
              label-width="110px"
              :inline="true"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购事项">
                    <el-input
                      v-model="dateForm.projectName"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="项目规模">
                    <el-input
                      v-model="dateForm.projectScale"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购计划编号">
                    <el-input
                      v-model="dateForm.bidPlanCode"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式：">
                    <el-input
                      v-model="dateForm.bidPurchaseMethod"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="预算控制价">
                    <el-input v-model="dateForm.estimatePrice" readonly></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="预算控制价单位">
                    <el-radio-group v-model="dateForm.estimatePriceUnit" >
                      <el-radio
                        v-for="item in list"
                        :label="item.value"
                        :key="item.value"
                        style="width: 80px; margin: 10px 0"
                        disabled
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="采购平台">
                    <el-input v-model="dateForm.bidPlatform" readonly></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 20px">
              
                  <el-table
                    ref="multipleTable"
                    :data="companyList"
                    border
                    size="mini"
                    style="width: 88%; margin-left: 110px"
                  >
                    <!-- <el-table-column type="selection" width="54"></el-table-column> -->
                    <el-table-column
                      v-for="(item, index) in tableColumns"
                      :key="index"
                      :prop="item.class"
                      :label="item.labelName"
                      :sortable="item.sortEnable"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                  </el-table>
              
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="选拨时间" >
                    <el-input v-model="dateForm.bidStartTime" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成交单位" >
                    <el-input v-model="dateForm.bidWinCompany" readonly></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="成交金额">
                    <el-input v-model="dateForm.bidWinPrice" readonly></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="成交金额单位" >
                    <el-radio-group v-model="dateForm.bidWinPriceUnit">
                      <el-radio
                        v-for="item in list"
                        :label="item.value"
                        :key="item.value"
                        style="width: 80px; margin: 10px 0"
                        disabled
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="info" @click="close1">关 闭</el-button>
    </div>
  </div>
</template>

<script>
import {
  getBidLedgerdetail, //获取一条采购计划信息
} from "@/services/bidServices";

import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //附件列表
import orderList from "./components/orderList"; //审核单情况
import { goBackApprove } from "@/page/approveComponents/approve";

export default {
  name: "controlOrder",
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
    upLoadFileDialog, //上传附件
    orderList, //  审核单情况
  },
  data() {
    return {
      activeName: "first", //活动tab页
      approveType: "BID_PLAN", //审批类型
      subapproveType: "bidplan", // 审批子类型
      approveFlag: "", //false：查看 true：审批
      companyList: [],
      tableColumns: [
        { class: "companyName", labelName: "响应/报价单位", sortEnable: false },
        {
          class: "offerPrice",
          labelName: "报价",
          sortEnable: false,
        },
        { class: "bidRemark", labelName: "选拨情况说明", sortEnable: false },
      ], //表格列
      bidPlanId: 276, //存储获取采购计划id
      dateForm: {
        id: 0,
        bidPlanCode: "", //采购计划编号
        projectId: "", //项目名称
        projectGeneral: "", //项目概括
        projectDeptName: "", //提报部门
        deptId: "", //提报部门
        attachmentList: [], //采购计划附件
        itemList: [], //计划条目列表
        status: "", //是否暂存标识 0：暂存，2：提交
        isUploadAllowed: false, //是否允许上传附件标识
      },
      list: [
        {
          value: 1,
          name: "万元",
        },
        {
          value: 0,
          name: "元",
        },
      ],
      controlOrderStyle: { height: 100 + "%" },
    };
  },
  // created() {
  //   console.log('222222222222222222')
  //   this.currentUserId = sessionStorage.getItem("currentUserId");
  // },
  mounted() {
    let ch3 = document.documentElement.clientHeight - 60;
    this.$set(this.controlOrderStyle, "height", ch3 + "px");

    window.onresize = () => {
      return (() => {
        let ch4 = document.documentElement.clientHeight - 60;
        this.$set(this.controlOrderStyle, "height", ch3 + "px");
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.approveFlag = this.tabRouteParam?.approveFlag ?? "";
      this.bidPlanId = this.tabRouteParam.id;
      this.getbidplanDetail(this.bidPlanId);
    },
    //获取一条采购计划信息
    getbidplanDetail(id) {
      let param = {};
      param.bidLedgerId = id;

      getBidLedgerdetail(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dateForm = res.data;
            this.companyList = res.data.bidCompanyList
            this.$forceUpdate()
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    close1() {
      if (this.approveFlag) {
        goBackApprove(this.approveFlag, "bidLedgerDetail");
        return;
      } else {
        this.bus.$emit("tabClose", "bidLedgerDetail");
      }

      this.bus.$emit("navMenuChange", {
        routeId: "bidLedger",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.bidOrderDetail {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

  .bottomBtn {
    position: fixed;
    left: 540px;
    width: 800px;
    height: 60px;
    line-height: 60px;
  }
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.screenPanel {
  text-align: left;
  height: auto;
  padding-bottom: 16px;
  margin-top: 20px;
  border-bottom: 1px solid #e6e6e6;
}

.el-select {
  width: 100%;
}

/deep/.el-header {
  position: relative;
}

.el-form-item {
  margin-bottom: 14px;
}

.el-select {
  margin-right: 10px;
}
/deep/.el-tabs__item.is-top.is-active {
    margin-left: 20px;
}
.firstTab {
  width: 72%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 90%;
  }
}
</style>
